import React from 'react';
import Icon from '../../../components/AppIcon';

const AuthMethodSelector = ({ selectedMethod, onMethodChange }) => {
  const authMethods = [
    {
      id: 'standard',
      label: 'Standard Login',
      icon: 'User',
      description: 'Email and password'
    },
    {
      id: 'otp',
      label: 'OTP Verification',
      icon: 'Smartphone',
      description: 'One-time password'
    },
    {
      id: 'faceid',
      label: 'Face ID',
      icon: 'Scan',
      description: 'Biometric authentication'
    }
  ];

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-foreground mb-3">
        Authentication Method
      </label>
      <div className="grid grid-cols-1 gap-3">
        {authMethods?.map((method) => (
          <button
            key={method?.id}
            type="button"
            onClick={() => onMethodChange(method?.id)}
            className={`
              w-full p-4 rounded-lg border-2 transition-smooth text-left
              ${selectedMethod === method?.id
                ? 'border-primary bg-primary/5 text-primary' :'border-border bg-card hover:border-primary/50 text-foreground'
              }
            `}
          >
            <div className="flex items-center space-x-3">
              <div className={`
                w-10 h-10 rounded-lg flex items-center justify-center
                ${selectedMethod === method?.id
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground'
                }
              `}>
                <Icon name={method?.icon} size={20} />
              </div>
              <div className="flex-1">
                <h3 className="font-medium">{method?.label}</h3>
                <p className="text-sm opacity-70">{method?.description}</p>
              </div>
              {selectedMethod === method?.id && (
                <Icon name="Check" size={20} className="text-primary" />
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AuthMethodSelector;